import React from "react";

export default function Section({
  id,
  overline,
  className = "",
  children,
  testId,
}) {
  return (
    <section
      id={id}
      className={`relative py-24 md:py-32 ${className}`}
      data-testid={testId}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {overline && (
          <div className="mb-6 inline-flex items-center gap-3 font-display text-[11px] uppercase tracking-[0.28em] text-white/70 font-bold">
            <span className="inline-block w-6 h-px bg-brand-orange" />
            {overline}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
